import Marquee from "react-fast-marquee";

const WORDS = ["Compassion", "Dignity", "Respect", "Excellence"];

export const ValuesMarquee = () => (
  <div data-testid="values-marquee" className="bg-brand-mist py-9 border-y border-brand-teal/10 overflow-hidden" aria-hidden="true">
    <Marquee speed={28} gradient={false}>
      {[...WORDS, ...WORDS].map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic text-3xl md:text-4xl leading-[1.4] text-brand-navy/80 tracking-wide">{w}</span>
          <span className="mx-14 h-2.5 w-2.5 rounded-full bg-brand-teal/50" />
        </span>
      ))}
    </Marquee>
  </div>
);
